import React from 'react'
import "./css/footer.css"
function Footer() {
    return (
        <div className="footer">
            <ul>
                <li>Aide</li>
                <li>Achat</li>
                <li>Sécurisé</li>
                <li>Règlement</li>
                <li>Publicité</li>
                <li>Qui sommes-nous</li>
            </ul>
        </div>
    )
}

export default Footer
